import { Flex, Spin, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useGetOrderSimIndicesQuery } from "../api/apiSlice";
import Container from "../components/Container";
import LogoImage from "../components/LogoImage";
import MenuButton from "../components/MenuButton";

const { Title, Text } = Typography;

type PageParams = {
  orderNumber: string;
};

export default function OrderSimsPage() {
  const { orderNumber } = useParams<PageParams>();
  const navigate = useNavigate();
  const { data: simOptions = [], error, isLoading } = useGetOrderSimIndicesQuery(
    { orderNo: orderNumber ?? "" },
    { skip: !orderNumber }
  );

  const displayOrderNumber = orderNumber ?? "";

  return (
    <Container>
      <LogoImage />
      <Title level={3}>Order ID: {displayOrderNumber}</Title>
      <img
        alt=""
        src="/images/sim-card-placeholder.jpg"
        style={{ borderRadius: 16, width: "100%" }}
      />

      {isLoading && (
        <Flex align="center" justify="center">
          <Spin />
        </Flex>
      )}

      {error && <Title level={4}>Failed to load order data</Title>}

      {!isLoading && !error && simOptions.length === 0 && (
        <Text>No SIMs found for this order.</Text>
      )}

      {!isLoading && !error && simOptions.length > 0 && (
        <Flex vertical gap={12}>
          {simOptions.map(({ simIdx, title }) => (
            <MenuButton
              key={simIdx}
              onClick={() => navigate(`/${encodeURIComponent(displayOrderNumber)}/${simIdx}`)}
            >
              #{simIdx}{title ? `: ${title}` : ""}
            </MenuButton>
          ))}
        </Flex>
      )}
    </Container>
  );
}
